import { SenecBaseTheme } from "src/newsenec-ui-components";
import { mobileStyle, desktopStyle } from "src/components/modal/senec-drawer/SenecDrawer.styled";
import { Typography, TypographyProps, Box, BoxProps, styled, Divider, DividerProps } from "@mui/material";

export const ScrollableBox = styled(Box)<BoxProps>(({ theme }) => {
    return {
        overflow: "auto",
        padding: `0 ${desktopStyle.drawerPaddingModerate}`,
        flexGrow: 1,
        [theme.breakpoints.down("sm")]: {
            padding: `0 ${mobileStyle.drawerPaddingModerate}`,
        },
    };
});

export const CompoundHeaderBox = styled(Box)<BoxProps>(({ theme }) => {
    const senecBaseTheme = theme as SenecBaseTheme;
    return {
        background: senecBaseTheme.palette.white.main,
        padding: desktopStyle.drawerPaddingModerate,
        [theme.breakpoints.down("sm")]: {
            padding: `${mobileStyle.drawerPaddingModerate}`,
        },
    };
});

export const Puller = styled(Box)<BoxProps>(({ theme }) => {
    const senecBaseTheme = theme as SenecBaseTheme;
    return {
        [theme.breakpoints.down("sm")]: {
            width: 100,
            height: 6,
            backgroundColor: senecBaseTheme.palette.neutralGray70.main,
            borderRadius: 3,
            position: "absolute",
            top: 10,
            left: "calc(50% - 50px)",
        },
    };
});

export const HeaderBox = styled(Box)<BoxProps>(() => ({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    padding: 0,
}));

export const TitleBox = styled(Box)<BoxProps>(() => {
    return {
        width: "100%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        zIndex: 1,
        paddingRight: desktopStyle.drawerPaddingNarrow,
    };
});

export const HeaderTitle = styled(Typography)<TypographyProps>(() => ({
    paddingTop: "8px",
    fontSize: "24px",
    lineHeight: "125%",
    width: "fit-content",
}));

export const HeaderDivider = styled(Divider)<DividerProps>(({ theme }) => ({
    marginBottom: desktopStyle.drawerPaddingModerate,
    [theme.breakpoints.down("sm")]: {
        marginBottom: `${mobileStyle.drawerPaddingModerate}`,
    },
}));

export const TopComponentBox = styled(Box)<BoxProps>(({ theme }) => ({
    paddingTop: desktopStyle.drawerPaddingNarrow,
    [theme.breakpoints.down("sm")]: {
        paddingTop: mobileStyle.drawerPaddingNarrow,
    },
}));

export const MainComponentBox = styled(Box)<BoxProps>(({ theme }) => ({
    height: "100%",
    paddingBottom: desktopStyle.drawerPaddingWide,

    [theme.breakpoints.down("sm")]: {
        paddingBottom: "32px",
    },
}));

export const BottomComponentBox = styled(Box)<BoxProps>(({ theme }) => {
    const senecBaseTheme = theme as SenecBaseTheme;

    return {
        position: "sticky",
        bottom: 0,
        zIndex: 2,
        background: senecBaseTheme.palette.white.main,
        padding: desktopStyle.drawerPaddingModerate,
        [theme.breakpoints.down("sm")]: {
            padding: `${mobileStyle.drawerPaddingModerate}`,
        },
    };
});
